import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// Provider Pages
import ProviderDashboard from './pages/provider/ProviderDashboard';
import ProviderFeasibilityCheck from './pages/provider/ProviderFeasibilityCheck';
import ProviderNegotiationPage from './pages/provider/ProviderNegotiationPage';
import ProviderOrderExecution from './pages/provider/ProviderOrderExecution';
import ProviderResultsDelivery from './pages/provider/ProviderResultsDelivery';
import ProviderIncomingRequests from './pages/provider/ProviderIncomingRequests';

// Shared/Common Pages
import ProviderRequestsPage from './pages/provider/ProviderRequestsPage';
import SettingsPage from './pages/SettingsPage';
import HelpSupportPage from './pages/HelpSupportPage';
import ProviderProfileManagementPage from './pages/provider/ProviderProfileManagementPage';
import ProviderDataMappingWizard from './pages/provider/ProviderDataMappingWizard';
import ProviderNetworkTab from './pages/provider/ProviderNetworkTab';
import ProviderOMOPChatPage from './pages/provider/ProviderOMOPChatPage';
import LoginPage from './auth/LoginPage';
import { AuthProvider } from './auth/authContext';
import ProtectedRoute from './auth/ProtectedRoute';

// Client Pages
import ClientMyRequestsPage from './pages/client/ClientMyRequestsPage';
import ClientDataRequestPage from './pages/client/ClientDataRequestPage';
import ClientReportsPage from './pages/client/ClientReportsPage';
import ClientDashboard from './pages/client/ClientDashboard';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Öffentliche Route für Login */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Geschützte Routen */}
          <Route path="/" element={
            <ProtectedRoute>
              <ProviderDashboard />
            </ProtectedRoute>
          } />
          <Route path="/incoming-requests" element={
            <ProtectedRoute>
              <ProviderRequestsPage />
            </ProtectedRoute>
          } />
          <Route path="/feasibility-check" element={
            <ProtectedRoute>
              <ProviderFeasibilityCheck />
            </ProtectedRoute>
          } />
          <Route path="/negotiation" element={
            <ProtectedRoute>
              <ProviderNegotiationPage />
            </ProtectedRoute>
          } />
          <Route path="/order-execution" element={
            <ProtectedRoute>
              <ProviderOrderExecution />
            </ProtectedRoute>
          } />
          <Route path="/results-delivery" element={
            <ProtectedRoute>
              <ProviderResultsDelivery />
            </ProtectedRoute>
          } />
          <Route path="/settings" element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          } />
          <Route path="/help" element={
            <ProtectedRoute>
              <HelpSupportPage />
            </ProtectedRoute>
          } />
          <Route path="/profile-management" element={
            <ProtectedRoute>
              <ProviderProfileManagementPage />
            </ProtectedRoute>
          } />
          <Route path="/data-mapping" element={
            <ProtectedRoute>
              <ProviderDataMappingWizard />
            </ProtectedRoute>
          } />
          <Route path="/network" element={
            <ProtectedRoute>
              <ProviderNetworkTab />
            </ProtectedRoute>
          } />
          <Route path="/omop-chat" element={
            <ProtectedRoute>
              <ProviderOMOPChatPage />
            </ProtectedRoute>
          } />

          {/* Client Routes */}
          <Route path="/client/dashboard" element={
            <ProtectedRoute>
              <ClientDashboard />
            </ProtectedRoute>
          } />
          <Route path="/client/my-requests" element={
            <ProtectedRoute>
              <ClientMyRequestsPage />
            </ProtectedRoute>
          } />
          <Route path="/client/new-request" element={
            <ProtectedRoute>
              <ClientDataRequestPage />
            </ProtectedRoute>
          } />
          <Route path="/client/reports" element={
            <ProtectedRoute>
              <ClientReportsPage />
            </ProtectedRoute>
          } />
          <Route path="/client/reports/:id" element={
            <ProtectedRoute>
              <ClientReportsPage />
            </ProtectedRoute>
          } />

          {/* Standardroute zum Login umleiten */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
